import { Result as AntResult, type ResultProps } from 'antd'

export type UiResultProps = ResultProps

export const UiResult = (props: UiResultProps) => <AntResult {...props} />

export default UiResult
